<template>
  <v-container id="eixo-list">
    <v-row>
      <v-col class="col-values">
        <v-btn
          outlined
          color="primary"
          class="ml-3"
          @click="
            $router.push(
              `/cidade/${municipioId}/agenteTerritorial/${tabType}/0`
            )
          "
        >
          Adicionar
        </v-btn>
      </v-col>
    </v-row>

    <v-row>
      <v-col>
        <v-text-field
          v-model="search"
          append-icon="mdi-magnify"
          label="Pesquise..."
        ></v-text-field>
      </v-col>
    </v-row>

    <v-row>
      <v-col>
        <v-data-table
          :headers="headers"
          :items="values"
          class="elevation-1"
          hide-default-footer
          disable-pagination
          :search="search"
        >
          <template slot="no-data">
            <span> Nenhuma Vocação </span>
          </template>

          <template v-slot:item.actions="{ item }">
            <v-btn
              outlined
              color="warning"
              class="mr-3"
              @click="
                $router.push(
                  `/cidade/${municipioId}/agenteTerritorial/${tabType}/${item.idVocacao}`
                )
              "
            >
              <v-icon>mdi-pencil</v-icon>
            </v-btn>

            <modalDelete :payload="item" @onDelete="load()">
              <template v-slot:title> Deletar Vocação </template>
            </modalDelete>
          </template>
        </v-data-table>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import { vocacoesApi } from "../Api/vocacoes";
import modalDelete from "./modalDelete";
export default {
  components: {
    modalDelete,
  },
  data() {
    return {
      headers: [
        { text: "Setor Econômico", value: "setorEconomico" },
        { text: "CNAES", value: "cnaes" },
        { text: "Ocupações", value: "ocupacoes" },
        { text: "Observações", value: "observacoes" },
        {
          text: "Ações",
          value: "actions",
        },
      ],
      municipioId: this.$route.params.id,
      tabType: this.$route.params.tab,

      values: [],
      search: "",
    };
  },

  methods: {
    ...mapActions(["setLoading"]),
    load() {
      this.setLoading(true);
      vocacoesApi.getByMunicipio(this.municipioId).then(({ data }) => {
        this.values = data;
        this.setLoading(false);
      });
    },
  },

  mounted() {
    this.load();
  },

  computed: {
    ...mapGetters(["isFullAdmin", "config"]),
  },
};
</script>
<style scoped>
.col-values {
  display: flex;
  justify-content: flex-end;
}
</style>
